module.exports = __webpack_public_path__ + "img/1f995.0dd7cfd.svg";